import { Component } from '@angular/core';
import { SiFooterComponent } from '@siemens/element-ng/footer';
import { Link } from '@siemens/element-ng/link';

@Component({
    selector: 'app-scf-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [SiFooterComponent]
})
export class FooterComponent {
    public year = new Date().getFullYear();
    public footerLinks: Link[] = [
        {
            title: 'Corporate Information',
            href: 'https://www.siemens.com/global/en/general/legal.html',
            target: '_blank'
        },
        {
            title: 'Privacy Notice',
            href: 'https://www.siemens.com/global/en/general/privacy-notice.html',
            target: '_blank'
        },
        {
            title: 'Cookie Notice',
            href: 'https://www.siemens.com/global/en/general/cookie-notice.html',
            target: '_blank'
        },
        {
            title: 'Terms of Use',
            href: 'https://www.siemens.com/global/en/general/terms-of-use.html',
            target: '_blank'
        },
        { title: 'Digital ID', href: 'https://www.siemens.com/global/en/general/digital-id.html', target: '_blank' },
        { title: 'Whistleblowing', href: 'https://intranet.siemens.de/whistleblowing', target: '_blank' },
        {
            target: '_blank',
            href: 'https://gms.siemens.cloud/',
            title: 'Powered by GMS'
        }
    ];
}
